import gql from 'graphql-tag';

export default gql`
    query GetAllTrailerTypes{
        getAllTrailerTypes{
            id
            name
        }
    }
`;
